var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',_vm._g(_vm._b({staticClass:"badge",style:({ backgroundColor: _vm.getBackgroundColor(), color: _vm.getTextColor() })},'span',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.badge.text.length ? _vm.badge.text : _vm.$t("smartcollege.badge.add"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }